import PropTypes from "prop-types";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { v4 } from "uuid";

import { updateProfile } from "store/auth";

import DarkModeSlider from "./DarkModeSlider";

const Settings = ({ handleClose, show }) => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.firebase.profile);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Settings</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Row>
            <Form.Label column xs={4}>
              Dark Mode
            </Form.Label>
            <Col>
              <DarkModeSlider />
            </Col>
          </Form.Row>
        </Form.Group>
        {profile.isLoaded && !profile.isEmpty ? (
          <>
            {profile.priceSources?.map((priceSource, i) => (
              <Form.Group key={v4()}>
                <Form.Row>
                  <Form.Label column xs={4}>
                    {`Price Source ${i + 1}`}
                  </Form.Label>
                  <Col>
                    <Form.Control
                      as="select"
                      onChange={(e) => {
                        const priceSources = [
                          ...profile.priceSources.slice(0, i),
                          e.target.value,
                          ...profile.priceSources.slice(i + 1),
                        ];
                        dispatch(updateProfile({ priceSources }));
                      }}
                      value={priceSource}
                    >
                      <option value="cardkingdom">Card Kingdom</option>
                      <option value="tcgplayer">TCGplayer</option>
                      <option value="cardhoarder">Cardhoarder (MTGO)</option>
                      <option value="cardmarket">Cardmarket (EU)</option>
                    </Form.Control>
                  </Col>
                </Form.Row>
              </Form.Group>
            ))}
            <Form.Group>
              <Form.Row>
                <Form.Label column xs={4}>
                  Names Under Cards
                </Form.Label>
                <Col>
                  <div className="d-flex h-100">
                    <Form.Check
                      checked={profile?.namesUnderCards}
                      inline
                      onClick={() =>
                        dispatch(
                          updateProfile({
                            namesUnderCards: !profile?.namesUnderCards,
                          })
                        )
                      }
                      type="checkbox"
                    />
                  </div>
                </Col>
              </Form.Row>
            </Form.Group>
            <Form.Row>
              <Form.Label column xs={4}>
                Show Salt
              </Form.Label>
              <Col>
                <ButtonGroup>
                  {["Never", "High Salt", "Always"].map((label, i) => (
                    <Button
                      key={label}
                      onClick={() => dispatch(updateProfile({ saltLevel: i }))}
                      variant={profile.saltLevel === i ? "primary" : "secondary"}
                    >
                      {label}
                    </Button>
                  ))}
                </ButtonGroup>
              </Col>
            </Form.Row>
          </>
        ) : (
          <div className="d-flex align-items-center">
            <Link to="/signin">
              <Button onClick={handleClose}>Sign in</Button>
            </Link>
            <span className="ml-2">to view more settings</span>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

Settings.propTypes = {
  handleClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Settings;
